import React from 'react';

const AdvertiserMainController = ({
  data,
  createAdvertiser,
  refetch,
  mediajelAdminId,
  mediajelId,
  locationData,
  attributionAudiences,
  currentOrgId,
  permission,
  orgLevel,
  ...props
}) => {
  const { isSelfService } = permission;
  // Filter locations
  const filteredLocations =
    locationData && locationData.locations
      ? locationData.locations.filter(
          (location) => location.audienceType === 'ATTRIBUTION' && location.org.id === currentOrgId
        )
      : [];

  // Filter location groups. Only show audiences with geoTargets
  const edges =
    attributionAudiences && attributionAudiences.audiencesConnection
      ? attributionAudiences.audiencesConnection.edges
      : undefined;

  const filteredAudiences = edges
    ? edges.filter((edge) => edge.node && edge.node.geoTargets && edge.node.geoTargets.length > 0)
    : [];

  const onCreateAdvertiser = async (values) => {
    try {
      await createAdvertiser({
        variables: {
          data: {
            name: values.name,
            startDate: values.startDate,
            endDate: values.endDate,
            transactions: 0,
            revenue: 0,
            customers: 0,
            clicks: 0,
            impressions: 0,
            pageViews: 0,
            signUps: 0,
            status: 'ACTIVE',
            impressionsTag: {
              connect: { id: values.campaignFilters[0].impressionsTag },
            },
            transactionsTags: {
              create: values.transactionsTags.map((tag) => ({
                eventsTarget: {
                  connect: {
                    id: tag.eventsTarget.connect.id,
                  },
                },
                trackMesurements: tag.trackMesurements,
              })),
            },
            sharedOrgs: {
              create: [
                ...values.campaignFilters.map((campaign) => ({
                  isAdmin: false,
                  isImpressionsOrg: true,
                  isMeasurementOrg: false,
                  org: {
                    connect: {
                      id: campaign.selectedImpresionsTagOrgId,
                    },
                  },
                })),
                ...values.transactionsTags.map((tag) => ({
                  isAdmin: false,
                  isImpressionsOrg: false,
                  isMeasurementOrg: true,
                  org: {
                    connect: {
                      id: tag.eventsTarget.connect.orgId,
                    },
                  },
                })),
              ],
            },
            locations: values.locations,
            attributionFilter: values.attributionFilter,
            campaigns: {
              create: values.campaignFilters.map((campaign) => {
                return {
                  insertionOrderId: campaign.insertionOrderId ? campaign.insertionOrderId : null,
                  lineItemIds: { set: campaign.lineitemIds },
                  name: campaign.lineItemName,
                  advertiserId: campaign.advertiserId,
                  impressionsTag: {
                    connect: {
                      id: campaign.impressionsTag,
                    },
                  },
                };
              }),
            },
          },
        },
      });
      await refetch();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <React.Fragment>
      {React.cloneElement(props.children, {
        ...props,
        data,
        currentOrgId,
        onCreateAdvertiser,
        filteredLocations,
        filteredAudiences,
        isSelfService,
        orgLevel,
      })}
    </React.Fragment>
  );
};

export default AdvertiserMainController;
